import gql from "graphql-tag";

const GET_UNREAD_COUNT = gql`
  query getRealtorClientRegistrationCount($input: RegistrationCountFilter) {
    getRealtorClientRegistrationCount(filter: $input)
  }
`;

export default GET_UNREAD_COUNT;
